export default __webpack_public_path__ + "static/media/independenceDay.2a812eb6.png";